import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, type RefObject } from 'react';

/**
 * Publishes the height of an element that sticks to the top of the page, as a
 * custom property on the root, and 0 whenever it does not stick.
 *
 * The page adds these up into its scroll padding, so that the browser scrolls
 * a field the focus moves to into view below what sticks, not behind it.
 */
export const useStickyHeight = (element, property) => {
  const $ = _c(6);
  let t0;
  if ($[0] !== element.current || $[1] !== property) {
    t0 = () => {
      const sticky = element.current;
      if (!sticky) {
        return;
      }
      const root = document.documentElement;
      const publish = () => {
        const sticks = getComputedStyle(sticky).position === "sticky";
        root.style.setProperty(property, sticks ? `${sticky.offsetHeight}px` : "0px");
      };
      const observer = new ResizeObserver(publish);
      observer.observe(sticky);
      window.addEventListener("resize", publish);
      publish();
      return () => {
        observer.disconnect();
        window.removeEventListener("resize", publish);
        root.style.removeProperty(property);
      };
    };
    $[0] = element.current;
    $[1] = property;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== element || $[4] !== property) {
    t1 = [element, property];
    $[3] = element;
    $[4] = property;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  useLayoutEffect(t0, t1);
};